import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PaymentSection from './components/PaymentSection';

import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import PrivateRoute from './components/Auth/PrivateRoute';

import Dashboard from './components/Dashboard/Dashboard';
import Profil from './components/Dashboard/Profil';
import RendezVous from './components/Dashboard/RendezVous';
import Planning from './components/Dashboard/Planning';
import Historique from './components/Dashboard/Historique';
import Avis from './components/Dashboard/Avis';

import AdminLogin from './components/Admin/AdminLogin';
import AdminDashboard from './components/Admin/AdminDashboard';
import AdminRoute from './components/Admin/AdminRoute';
import GestionRendezVous from './components/Admin/GestionRendezVous';
import GestionClients from './components/Admin/GestionClients';
import GestionAvis from './components/Admin/GestionAvis';
import AdminStats from './components/Admin/AdminStats';

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      delay: 0
    });
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <AuthProvider>
          <div className="App">
            <Routes>
              {/* ========== ROUTES PUBLIQUES ========== */}
              <Route 
                path="/" 
                element={
                  <>
                    <Navbar />
                    <Hero />
                    <Services />
                    <WhyUs />
                    <PaymentSection />
                    <Testimonials />
                    <Contact />
                    <Footer />
                  </>
                } 
              />
              
              <Route 
                path="/paiement" 
                element={
                  <>
                    <Navbar />
                    <PaymentSection />
                    <Footer />
                  </>
                } 
              />
              
              <Route 
                path="/login" 
                element={
                  <>
                    <Navbar />
                    <Login />
                    <Footer />
                  </>
                } 
              />
              
              <Route 
                path="/register" 
                element={
                  <>
                    <Navbar />
                    <Register />
                    <Footer />
                  </>
                } 
              />
              
              {/* ========== ROUTES DASHBOARD CLIENT ========== */}
              <Route 
                path="/dashboard" 
                element={
                  <PrivateRoute>
                    <>
                      <Navbar />
                      <Dashboard />
                      <Footer />
                    </>
                  </PrivateRoute>
                }
              >
                <Route index element={<Profil />} />
                <Route path="rendezvous" element={<RendezVous />} />
                <Route path="planning" element={<Planning />} />
                <Route path="historique" element={<Historique />} />
                <Route path="avis" element={<Avis />} />
              </Route>
              
              {/* ========== ROUTES ADMIN ========== */}
              <Route path="/admin" element={<AdminLogin />} />
              
              <Route 
                path="/admin/dashboard" 
                element={
                  <AdminRoute>
                    <AdminDashboard />
                  </AdminRoute>
                }
              >
                <Route index element={<AdminStats />} />
                <Route path="rendezvous" element={<GestionRendezVous />} />
                <Route path="clients" element={<GestionClients />} />
                <Route path="avis" element={<GestionAvis />} />
              </Route>
              
              {/* ========== ROUTE 404 ========== */}
              <Route 
                path="*" 
                element={
                  <>
                    <Navbar />
                    <div className="not-found-container">
                      <h1>404</h1>
                      <h2>Page non trouvée</h2>
                      <p>La page que vous recherchez n'existe pas ou a été déplacée.</p>
                      <a href="/" className="btn btn-primary">Retour à l'accueil</a>
                    </div>
                    <Footer />
                  </>
                } 
              />
            </Routes>
          </div>
        </AuthProvider>
      </Router>
    </HelmetProvider>
  );
}

export default App;